import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Course } from '../../courses/shared/course';
import { Lesson } from '../../lessons/shared/lesson';
import { Lecture } from '../shared/lecture';
import { LectureLessonService } from '../shared/lecture-lesson.service';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-lecture',
  templateUrl: './lecture.component.html',
  styleUrls: ['./lecture.component.scss']
})
export class LectureComponent implements OnInit {
  @Input() course: Course;
  @Input() lecture: Lecture;
  lessonsObservable: Observable<Lesson[]>;
  AppConfig: any;

  constructor(private refService: LectureLessonService) { }

  ngOnInit() {
    this.lessonsObservable = this.refService.readList(this.lecture.$key, 'name');
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture/lecture.component.ts